
export default class feedbackModel {
    constructor({request}) {
        this.request = request;
    }

    async addBase64Image(params) {
        return this.request.fetch('zebra/POST/CommonService/generateImage', params);
    }

    async addFeedback(params) {
        return this.request.fetch('natasha/Post/FeedBackService/addFeedback', params);
    }
}
